export default __webpack_public_path__ + "static/differentiate-headings-dont-2a7d0b7516845a4c1e56068e65a57c8c.png";